import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function PortalCalendar() {
  const { summary } = useOutletContext();
  const [cursor, setCursor] = useState(new Date());
  if (!summary) return <div className="p-8 text-neutral-500">Loading…</div>;
  const contents = summary.contents;

  const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const startDow = first.getDay();
  const daysInMonth = new Date(cursor.getFullYear(), cursor.getMonth()+1, 0).getDate();
  const cells = [];
  for (let i=0; i<startDow; i++) cells.push(null);
  for (let d=1; d<=daysInMonth; d++) cells.push(d);
  while (cells.length % 7) cells.push(null);

  const monthKey = cursor.toISOString().slice(0,7);
  const byDay = {};
  contents.forEach(c => {
    if (c.publishing_date?.startsWith(monthKey)) {
      const day = parseInt(c.publishing_date.slice(8,10),10);
      byDay[day] ||= []; byDay[day].push(c);
    }
  });

  return (
    <div className="p-6 md:p-8 space-y-6 max-w-[1600px]">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">Publishing Timeline</div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Content Calendar</h1>
        <p className="text-neutral-600 text-sm mt-1">See every scheduled post at a glance</p>
      </div>

      <div className="panel p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-lg tracking-tight">{cursor.toLocaleDateString(undefined, {month:"long", year:"numeric"})}</h3>
          <div className="flex gap-1">
            <Button variant="ghost" size="icon" onClick={()=>setCursor(new Date(cursor.getFullYear(), cursor.getMonth()-1, 1))} data-testid="portal-prev-month"><ChevronLeft className="w-4 h-4"/></Button>
            <Button variant="ghost" size="sm" onClick={()=>setCursor(new Date())} className="font-mono text-[11px] uppercase" data-testid="portal-today">Today</Button>
            <Button variant="ghost" size="icon" onClick={()=>setCursor(new Date(cursor.getFullYear(), cursor.getMonth()+1, 1))} data-testid="portal-next-month"><ChevronRight className="w-4 h-4"/></Button>
          </div>
        </div>
        <div className="grid grid-cols-7 gap-px bg-[#E4E7EC] rounded-lg overflow-hidden">
          {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d=>(
            <div key={d} className="bg-[#FFFFFF] p-2 text-[10px] font-mono uppercase tracking-wider text-neutral-500 text-center">{d}</div>
          ))}
          {cells.map((d,i)=> (
            <div key={i} className={`bg-[#FFFFFF] min-h-[100px] p-2 ${d?"":"opacity-40"}`} data-testid={d?`day-${d}`:undefined}>
              <div className="text-[11px] font-mono text-neutral-500">{d||""}</div>
              <div className="mt-1 space-y-1">
                {(byDay[d]||[]).slice(0,3).map(c=>(
                  <div key={c.id} className="text-[10px] font-mono px-1.5 py-0.5 rounded border border-[#E4E7EC] bg-[#FFFFFF] truncate">
                    <span className="text-neutral-600">{c.publishing_time}</span> <span className="text-neutral-800">{c.content_type}</span>
                  </div>
                ))}
                {(byDay[d]?.length||0) > 3 && <div className="text-[10px] font-mono text-orange-400">+{byDay[d].length-3}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
